var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mb-5"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items}})],1),_vm._m(1),_c('div',{staticClass:"mb-5"},[_c('b-table',{attrs:{"dark":"","hover":"","items":_vm.items}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-4"},[_c('strong',[_vm._v("Default Table")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-4"},[_c('strong',[_vm._v("Inverse Table")])])
}]

export { render, staticRenderFns }